import { render } from "./NotifySenderModal.vue?vue&type=template&id=3eb5c750"
import script from "./NotifySenderModal.vue?vue&type=script&lang=js"
export * from "./NotifySenderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__